import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import NavBar from '../components/NavBar';

const History = ({ user, onLogout }) => {
  const location = useLocation();
  const [checkins, setCheckins] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await axios.get(`${API}/checkins/history`);
        setCheckins(response.data);
      } catch (error) {
        toast.error('Failed to load check-in history');
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  const formatDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="dashboard-container" data-testid="history-page">
      <NavBar onLogout={onLogout} />

      <div className="dashboard-content page-container">
        <h1 className="page-title" data-testid="page-title">Check-in History</h1>

        <div className="section-card" data-testid="history-section">
          <h2 className="section-title">Recent Check-ins</h2>

          {loading ? (
            <p>Loading history...</p>
          ) : checkins.length === 0 ? (
            <div className="empty-state" data-testid="empty-history">
              <div className="empty-state-icon">📅</div>
              <p>No check-ins recorded yet</p>
            </div>
          ) : (
            <div className="history-list">
              {checkins.map((checkin) => (
                <div key={checkin.id} className="history-item" data-testid={`history-item-${checkin.id}`}>
                  <div>
                    <p style={{ color: '#2c5364', fontWeight: 600, marginBottom: '0.25rem' }}>
                      {formatDate(checkin.timestamp)}
                    </p>
                    <p style={{ color: '#6b8899', fontSize: '0.9rem' }}>Check-in ID: {checkin.id.slice(0, 8)}</p>
                  </div>
                  <span className="status-badge" data-testid={`status-${checkin.id}`}>
                    {checkin.status === 'ok' ? '✓ OK' : checkin.status}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default History;